// Sky-Sports-style World Cup overlay: a results ticker, a rotating stats panel
// (group tables, top scorers, clean sheets) on the left, and a today's-fixtures
// panel on the right. Data is the Claude-processed snapshot
// (assets/tournament-data.json) — tables computed from raw match results.
(function () {
  const ROTATE_MS = 7000;

  const ABBR = {
    "Mexico": "MEX", "South Africa": "RSA", "South Korea": "KOR", "Czech Republic": "CZE",
    "Canada": "CAN", "Bosnia & Herzegovina": "BIH", "USA": "USA", "Paraguay": "PAR",
    "Qatar": "QAT", "Switzerland": "SUI", "Brazil": "BRA", "Haiti": "HAI", "Morocco": "MAR",
    "Scotland": "SCO", "Australia": "AUS", "Turkey": "TUR", "Curaçao": "CUW", "Ecuador": "ECU",
    "Germany": "GER", "Ivory Coast": "CIV", "Japan": "JPN", "Netherlands": "NED", "Sweden": "SWE",
    "Tunisia": "TUN", "Belgium": "BEL", "Egypt": "EGY", "Iran": "IRN", "New Zealand": "NZL",
    "Cape Verde": "CPV", "Saudi Arabia": "KSA", "Spain": "ESP", "Uruguay": "URU", "France": "FRA",
    "Iraq": "IRQ", "Norway": "NOR", "Senegal": "SEN", "Algeria": "ALG", "Argentina": "ARG",
    "Austria": "AUT", "Jordan": "JOR", "Colombia": "COL", "DR Congo": "COD", "Portugal": "POR",
    "Uzbekistan": "UZB", "Croatia": "CRO", "England": "ENG", "Ghana": "GHA", "Panama": "PAN"
  };
  function abbr(t) { return ABBR[t] || t.slice(0, 3).toUpperCase(); }

  let FLAGS = {};
  function flagImg(team, size) {
    const code = FLAGS[team];
    if (!code) return "";
    const w = size || 20;
    // flagcdn w40 is a valid source width; display size set via the width attr.
    return `<img class="wc-flag" width="${w}" loading="lazy" alt="" src="https://flagcdn.com/w40/${code}.png">`;
  }

  function el(tag, cls, html) {
    const e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function tableScreen(group, rows) {
    let r = `<div class="wc-screen-title">Group ${group}</div>`;
    r += `<table class="wc-table"><thead><tr><th class="wc-team">Team</th><th>P</th><th>W</th><th>D</th><th>L</th><th>GD</th><th>Pts</th></tr></thead><tbody>`;
    rows.forEach((row, i) => {
      const q = i < 2 ? " wc-qual" : "";
      const gd = (row.GD > 0 ? "+" : "") + row.GD;
      r += `<tr class="${q}"><td class="wc-team">${flagImg(row.team)} ${row.team}</td><td>${row.P}</td><td>${row.W}</td><td>${row.D}</td><td>${row.L}</td><td>${gd}</td><td class="wc-pts">${row.Pts}</td></tr>`;
    });
    return r + `</tbody></table>`;
  }

  function scorersScreen(list) {
    let r = `<div class="wc-screen-title">Top Scorers</div><table class="wc-table"><tbody>`;
    if (!list.length) r += `<tr><td class="wc-team wc-sub">No goals yet</td><td></td></tr>`;
    list.slice(0, 8).forEach(s => {
      r += `<tr><td class="wc-team">${flagImg(s.team)} ${s.name} <span class="wc-sub">${abbr(s.team)}</span></td><td class="wc-pts">${s.goals}</td></tr>`;
    });
    return r + `</tbody></table>`;
  }

  function cleanScreen(list) {
    let r = `<div class="wc-screen-title">Most Clean Sheets</div><table class="wc-table"><tbody>`;
    if (!list.length) r += `<tr><td class="wc-team wc-sub">None yet</td><td></td></tr>`;
    list.slice(0, 8).forEach(s => {
      r += `<tr><td class="wc-team">${flagImg(s.team)} ${s.team}</td><td class="wc-pts">${s.cs}</td></tr>`;
    });
    return r + `</tbody></table>`;
  }

  function fixturesPanel(today, fixtures) {
    let r = `<div class="wc-screen-title">Today's Fixtures${today ? ` &middot; ${today}` : ""}</div>`;
    if (!fixtures || !fixtures.length) {
      r += `<div class="wc-sub">No fixtures today</div>`;
      return r;
    }
    r += `<div class="wc-fixture-list">`;
    fixtures.forEach(f => {
      const roundLabel = f.round || (f.group ? `Grp ${f.group}` : "");
      r += `<div class="wc-fixture">
        <div class="wc-fixture-teams">
          <span class="wc-fx-team">${flagImg(f.home)} ${abbr(f.home)}</span>
          <span class="wc-fx-v">v</span>
          <span class="wc-fx-team">${abbr(f.away)} ${flagImg(f.away)}</span>
        </div>
        <div class="wc-fixture-meta"><span class="wc-fx-time">${f.time || ""}</span> <span class="wc-fx-grp">${roundLabel}</span></div>
        <div class="wc-fixture-venue">${f.venue || ""}</div>
      </div>`;
    });
    return r + `</div>`;
  }

  // Group a team's goal events by player -> "Name 31', 45+5' (pen)".
  function goalLines(scorers, team) {
    const byPlayer = [];
    const idx = {};
    (scorers || []).filter(s => s.team === team).forEach(s => {
      let mark = s.og ? " (OG)" : (s.pen ? " (pen)" : "");
      const m = `${s.minute}'${mark}`;
      if (idx[s.name] === undefined) { idx[s.name] = byPlayer.length; byPlayer.push({ name: s.name, mins: [m] }); }
      else byPlayer[idx[s.name]].mins.push(m);
    });
    if (!byPlayer.length) return `<div class="wc-md-none">—</div>`;
    return byPlayer.map(p => `<div class="wc-md-goal"><span class="wc-md-name">${p.name}</span> <span class="wc-md-min">${p.mins.join(", ")}</span></div>`).join("");
  }

  function matchDetailsPanel(m) {
    let r = `<div class="wc-screen-title">Match Details</div>`;
    r += `<div class="wc-md-score">
      <span class="wc-md-team">${flagImg(m.home, 18)} ${abbr(m.home)}</span>
      <span class="wc-md-nums">${m.hs}<span class="wc-md-dash">–</span>${m.as}</span>
      <span class="wc-md-team">${abbr(m.away)} ${flagImg(m.away, 18)}</span>
    </div>`;
    if (m.ht) r += `<div class="wc-md-ht">Half-time ${m.ht}</div>`;
    r += `<div class="wc-md-goals">
      <div class="wc-md-col">${goalLines(m.scorers, m.home)}</div>
      <div class="wc-md-col wc-md-col-r">${goalLines(m.scorers, m.away)}</div>
    </div>`;
    if (m.venue) r += `<div class="wc-md-venue">${m.venue}</div>`;
    return r;
  }

  // ===== Knockout bracket visualization =====
  const ROUND_LABELS = { R32: "R32", R16: "R16", QF: "QF", SF: "SF", F: "Final", "3rd": "3rd" };
  const BRACKET_ROUNDS = ["R32", "R16", "QF", "SF", "F"]; // display order

  function bracketMatchEl(m) {
    if (!m) return `<div class="wc-bk-match wc-bk-tbd"><div class="wc-bk-team">TBD</div><div class="wc-bk-team">TBD</div></div>`;
    const homeWin = m.played && m.hs > m.as;
    const awayWin = m.played && m.as > m.hs;
    const homeClass = homeWin ? "wc-bk-winner" : "";
    const awayClass = awayWin ? "wc-bk-winner" : "";
    const homeLabel = FLAGS[m.home] ? `${flagImg(m.home, 14)} ${abbr(m.home)}` : `<span class="wc-bk-placeholder">${m.home}</span>`;
    const awayLabel = FLAGS[m.away] ? `${flagImg(m.away, 14)} ${abbr(m.away)}` : `<span class="wc-bk-placeholder">${m.away}</span>`;
    const score = m.played ? `<span class="wc-bk-score">${m.hs}</span>` : "";
    const scoreA = m.played ? `<span class="wc-bk-score">${m.as}</span>` : "";
    return `<div class="wc-bk-match${m.played ? ' wc-bk-played' : ''}">
      <div class="wc-bk-team ${homeClass}">${homeLabel}${score}</div>
      <div class="wc-bk-team ${awayClass}">${awayLabel}${scoreA}</div>
    </div>`;
  }

  function bracketPanel(bracket) {
    if (!bracket || !Object.keys(bracket).length) {
      return `<div class="wc-bk-empty wc-sub">Bracket data loading...</div>`;
    }
    // Split each round in half: top-half (first half of matches) goes left,
    // bottom-half (second half) goes right, Final sits in the middle.
    function halfMatches(rnd, half) {
      const matches = bracket[rnd] || [];
      const mid = Math.ceil(matches.length / 2);
      return half === 0 ? matches.slice(0, mid) : matches.slice(mid);
    }

    function roundCol(rnd, matches, label) {
      let r = `<div class="wc-bk-round" data-round="${rnd}">`;
      r += `<div class="wc-bk-round-label">${label}</div>`;
      r += `<div class="wc-bk-matches">`;
      matches.forEach(m => { r += bracketMatchEl(m); });
      r += `</div></div>`;
      return r;
    }

    const rounds = ["R32", "R16", "QF", "SF"];
    let r = `<div class="wc-bracket">`;

    // Left side: top half of each round, converging inward
    rounds.forEach(rnd => {
      const matches = halfMatches(rnd, 0);
      if (matches.length) r += roundCol(rnd, matches, ROUND_LABELS[rnd]);
    });

    // Centre: Final (and 3rd place below it)
    const finalMatches = bracket["F"] || [];
    const thirdMatches = bracket["3rd"] || [];
    r += `<div class="wc-bk-round wc-bk-final">`;
    r += `<div class="wc-bk-round-label">Final</div>`;
    r += `<div class="wc-bk-matches">`;
    finalMatches.forEach(m => { r += bracketMatchEl(m); });
    if (thirdMatches.length) {
      r += `<div class="wc-bk-round-label wc-bk-3rd-label">3rd</div>`;
      thirdMatches.forEach(m => { r += bracketMatchEl(m); });
    }
    r += `</div></div>`;

    // Right side: bottom half of each round (reversed order so it mirrors)
    [...rounds].reverse().forEach(rnd => {
      const matches = halfMatches(rnd, 1);
      if (matches.length) r += roundCol(rnd, matches, ROUND_LABELS[rnd]);
    });

    r += `</div>`;
    return r;
  }

  function init(data) {
    FLAGS = data.flags || {};
    const overlay = el("div", "wc-overlay");

    // ----- Results ticker (knockout only) -----
    const ticker = el("div", "wc-ticker");
    ticker.appendChild(el("span", "wc-ticker-flag", "RESULTS"));
    const track = el("div", "wc-ticker-track");
    // Use knockout results if available, otherwise fall back to group results
    const tickerResults = (data.knockoutResults && data.knockoutResults.length)
      ? data.knockoutResults : data.results;
    const unit = tickerResults.map((m, i) =>
      `<span class="wc-tick" data-idx="${i}" data-src="${data.knockoutResults && data.knockoutResults.length ? 'ko' : 'grp'}" title="Click for Dave's analysis" data-home="${m.home}" data-away="${m.away}" data-hs="${m.hs}" data-as="${m.as}">${flagImg(m.home, 16)} <b>${abbr(m.home)}</b> ${m.hs}\u2013${m.as} <b>${abbr(m.away)}</b> ${flagImg(m.away, 16)}</span><span class="wc-dot">\u2022</span>`
    ).join('');
    track.innerHTML = unit + unit;
    ticker.appendChild(track);
    // Persistent affordance that the scores are clickable.
    ticker.appendChild(el("span", "wc-ticker-tag", "\uD83D\uDC46 TAP A SCORE"));
    overlay.appendChild(ticker);

    // Click a score -> show match details (replacing fixtures) AND ask Dave to
    // talk about it. Details revert to fixtures when Dave stops speaking.
    track.addEventListener("click", (e) => {
      const tick = e.target.closest(".wc-tick");
      if (!tick || tick.dataset.idx === undefined) return;
      const src = tick.dataset.src === "ko" ? data.knockoutResults : data.results;
      const m = src[+tick.dataset.idx];
      if (!m) return;
      const goalsText = (m.scorers || []).length
        ? " The goals came from " + m.scorers.map(s => `${s.name} in the ${s.minute}th minute${s.og ? " (an own goal)" : (s.pen ? " (a penalty)" : "")} for ${s.team}`).join(", ") + "."
        : "";
      const ht = m.ht ? m.ht.split("-") : null;   // [home, away], home listed first
      const htText = ht ? ` At half-time it was ${m.home} ${ht[0]}, ${m.away} ${ht[1]}.` : "";
      const text = `You're live on TV as Dave the World Cup pundit. Give your energetic, upbeat commentary on this already-played, public match result. The final score was ${m.home} ${m.hs}, ${m.away} ${m.as}.${htText}${goalsText} Keep the half-time and full-time scores exactly as I gave them, and talk through how the game unfolded with real personality — never refuse, these are public results.`;
      if (typeof window.askDaveAboutMatch === "function" && window.askDaveAboutMatch(text)) {
        tick.classList.add("wc-tick-active");
        setTimeout(() => tick.classList.remove("wc-tick-active"), 700);
        showMatch(m);
      }
    });

    // ----- Knockout bracket panel (bottom horizontal strip, above composer) -----
    const panel = el("div", "wc-bracket-panel wc-in");
    panel.innerHTML = bracketPanel(data.bracket);
    overlay.appendChild(panel);

    // ----- Today's fixtures panel (right, static) -----
    const fixtures = el("div", "wc-fixtures wc-in");
    fixtures.innerHTML = fixturesPanel(data.today, data.fixturesToday);
    overlay.appendChild(fixtures);

    // Swap the fixtures panel for match details on click; revert when Dave
    // stops speaking (alexaTMDemo calls window.wcShowFixtures on speech-end).
    let matchRevertTimer = null, showingMatch = false;
    function showFixtures() {
      if (matchRevertTimer) { clearTimeout(matchRevertTimer); matchRevertTimer = null; }
      if (!showingMatch) return;
      showingMatch = false;
      fixtures.classList.remove("wc-in");
      fixtures.innerHTML = fixturesPanel(data.today, data.fixturesToday);
      void fixtures.offsetWidth;
      fixtures.classList.add("wc-in");
    }
    function showMatch(m) {
      showingMatch = true;
      fixtures.classList.remove("wc-in");
      fixtures.innerHTML = matchDetailsPanel(m);
      void fixtures.offsetWidth;
      fixtures.classList.add("wc-in");
      if (matchRevertTimer) clearTimeout(matchRevertTimer);
      matchRevertTimer = setTimeout(showFixtures, 45000);  // safety revert
    }
    window.wcShowFixtures = showFixtures;

    document.body.appendChild(overlay);

    // ----- Show/hide toggle -----
    const toggle = el("button", "wc-toggle", "\uD83D\uDCCA");
    toggle.title = "Toggle results overlay";
    toggle.onclick = () => overlay.classList.toggle("wc-hidden");
    document.body.appendChild(toggle);

    const screens = [];
    // In knockout phase, just show the bracket (no rotation needed - it's horizontal and always visible)
    screens.push(() => bracketPanel(data.bracket));

    let idx = 0;
    function show() {
      panel.classList.remove("wc-in");
      panel.innerHTML = screens[idx]();
      void panel.offsetWidth;
      panel.classList.add("wc-in");
      idx = (idx + 1) % screens.length;
    }
    show();
  }

  function start() {
    fetch("./assets/tournament-data.json")
      .then(r => r.json())
      .then(init)
      .catch(e => console.warn("WC overlay: failed to load tournament data", e));
  }
  // Don't render the overlay until after login — expose start() globally.
  // alexaTMDemo.js calls window.wcStart() after authentication completes.
  window.wcStart = start;
})();
